import React from 'react'
import './Bottom.scss'

const Bottom = () => {
  return (
    <div className='bottom'></div>
  )
}

export default Bottom